import { render, staticRenderFns } from "./ProfSalonBatResolver.vue?vue&type=template&id=458e7c10&scoped=true"
import script from "./ProfSalonBatResolver.vue?vue&type=script&lang=ts"
export * from "./ProfSalonBatResolver.vue?vue&type=script&lang=ts"
import style0 from "./ProfSalonBatResolver.vue?vue&type=style&index=0&id=458e7c10&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458e7c10",
  null
  
)

export default component.exports